import MathUtil from "../common/utils/MathUtil";
import TechnologyPreviewItem from "./TechnologyPreviewItem";

class TechnologyPreview {
  // ---------------------------------------------------------------------------
  // --	TechnologyPreview
  // ---------------------------------------------------------------------------

  constructor() {
    //スライド用のインデックス
    this.index = 0;

    //DOM参照
    this.$elm = document.querySelector(".p-home-technology__preview");

    //アイテム生成＆タイマー配置
    this.items = [];
    this.$elm
      .querySelectorAll(".p-home-technology__preview-item")
      .forEach((elm) => {
        const item = new TechnologyPreviewItem(elm);
        this.items.push(item);
      });

    //ロールオーバー
    const linkItems = document.querySelectorAll(".p-home-technology__item");
    for (let i = 0; i < linkItems.length; i++) {
      const $linkItem = linkItems[i];
      $linkItem.querySelectorAll("a:nth-child(1)").forEach((elm) => {
        elm.addEventListener("mouseover", () => {
          this.change(i);
        });
      });
    }

    //最初のアイテム表示
    const item = this.items[this.index];
    item.show(0);

    // const radian = MathUtil.degreeToRadian(40);
    // const distance = 747 / Math.cos(radian);
    // const offsetY = Math.sin(radian) * distance;
    // console.log("offsetY:" + offsetY);
  }

  /**
   * 画像の切り替え
   */
  change(index) {
    if (this.index == index) return;

    //表示中のアイテムを隠す
    const prevItem = this.items[this.index];
    this.$elm.appendChild(prevItem.$elm);
    prevItem.hide();

    //インデックス更新
    this.index = index;

    //次のアイテムを表示する
    const nextItem = this.items[this.index];
    nextItem.show();
  }

  // ---------------------------------------------------------------------------
}

export default TechnologyPreview;
